import { Component, Input, OnInit } from '@angular/core';
import { ElementRef, EventEmitter, Output } from '@angular/core';

import { ContentChild } from '@angular/core';
import { RouteTypes } from '@app/enums/route-types.enum';

@Component({
  selector: 'app-hero-banner',
  templateUrl: './hero-banner.component.html',
  styleUrls: ['./hero-banner.component.scss'],
  standalone: false,
})
export class HeroBannerComponent implements OnInit {
  @Input() id: string;
  @Input() name: string;
  @Input() title: string;
  @Input() subTitle: string;
  @Input() route: string;
  @Input() queryParams: any;
  @Input() routeType = RouteTypes.INTERNAL; // Default indicates if the routeType is 'internal' for internal routing, anything else is external including mailTo: emails
  @Input() description: string;
  @Input() actionLabel: string;
  @Input() showButton = true;
  @Input() showSubTitle: boolean;
  @Input() showTitle = true; // Default to always show the title by default

  @Input() heroImageCss: string;
  @Input() alignContentCss: string;
  @Input() customHeadingCss: string;
  @Input() customDescriptionCss: string;
  @Input() customButtonCss = 'btn-primary larger-btn'; // Default primary button css
  @Input() gradientOverlayCss: string; // Add gradient overlay over image for responsive issues like text over images
  @Input() displayCss: string;

  // The content child allows to inject custom content into the hero banner
  @ContentChild('content', { static: true }) contentElement: ElementRef;
  @Output() sendClick = new EventEmitter<object>();

  constructor() {}

  /**
   * Default On Init
   */
  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}

  /**
   * On click handle from route button component and emit send click output to calling
   * component
   */
  onClick(): void {
    this.sendClick.emit({ clickButtonFlag: true, actionLabel: this.actionLabel });
  }
}
